import React from 'react';
import { Row, Col } from 'react-bootstrap';

const TitleHeader = ({ title }) => {
  return (
    <div className="title-header">
      <Row>
        <Col className="text-center">
          <h4>{title}</h4>
        </Col>
      </Row>
    </div>
  );
};

export default TitleHeader;
